import React from "react";
import { Drawer } from "antd";
import "./ActionSheet.css";

/**
 * Phone bottom sheet with a list of actions. Each child becomes one full-width row; buttons and
 * links inside a row are restyled as list items. Tapping a row closes the sheet after the row's
 * own handler ran (dialogs it opens are portaled, so they stay open).
 *
 *   <ActionSheet open={open} onClose={close} title={t("Actions")}>
 *     <Button onClick={edit}>{t("Edit")}</Button>
 *     <Button danger onClick={remove}>{t("Delete")}</Button>
 *   </ActionSheet>
 */
const ActionSheet = ({ open, onClose, title, children, closeOnSelect = true }) => (
  <Drawer
    rootClassName="action-sheet"
    placement="bottom"
    open={open}
    onClose={onClose}
    closable={false}
    height="auto"
    title={null}
    styles={{ header: { display: "none" }, body: { padding: 0 } }}
  >
    <div className="action-sheet__handle" aria-hidden="true" />
    {title && <div className="action-sheet__title">{title}</div>}
    <ul className="action-sheet__list" role="menu">
      {React.Children.toArray(children)
        .filter(Boolean)
        .map((child, i) => (
          <li
            key={child.key ?? i}
            className="action-sheet__item"
            role="none"
            // Capture phase: row buttons often stop propagation of their own clicks.
            onClickCapture={() => {
              if (closeOnSelect) setTimeout(onClose, 0);
            }}
            onClick={e => e.stopPropagation()}
          >
            {child}
          </li>
        ))}
    </ul>
  </Drawer>
);

export default ActionSheet;
